import styled from 'styled-components';
import { COLORS } from '../../../../../../../../../constants';

export const BorderWrapper = styled.div`
    border-top: 1px solid ${COLORS.SECONDARY};
    border-bottom: 1px solid ${COLORS.SECONDARY};
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    display: inline;
    color: ${COLORS.BLACK};
    padding-right: 2rem;
`;
